import { Input, Table, TableBody, TableCell, TableHeader, TableHeaderCell, TableRow } from 'semantic-ui-react';

const css = {
    uploadButton: {
        display: "flex",
        'alignItems': "center",
        'justifyContent': "center",
        border: "none",
        padding: "7px 0px",
        'borderRadius': "4px",
        'backgroundColor': "#f2f2f2",
        width: "165px",
        cursor: "pointer"
    },

    wrapper : {
        marginTop: '20px',
        marginBottom: '50px'
    }
}

export function DailyReportCreate() {


    return <div style={css.wrapper}>
        <Table basic='very'>
            <TableHeader>
                <TableRow>
                    <TableHeaderCell className='size-18'>Monnaie</TableHeaderCell>
                    <TableHeaderCell className='size-18'>Solde veille</TableHeaderCell>
                    <TableHeaderCell className='size-18'>Appro</TableHeaderCell>
                    <TableHeaderCell className='size-18'>Encaissement</TableHeaderCell>
                    <TableHeaderCell className='size-18'>Décaissement</TableHeaderCell>
                    <TableHeaderCell className='size-18'>Solde calculé</TableHeaderCell>
                    <TableHeaderCell className='size-18'>Image/PDF</TableHeaderCell>
                </TableRow>
            </TableHeader>

            <TableBody>
                <TableRow>
                    <TableCell>
                        <img src='/images/wave.jpg' alt='' width={42} height={40} className='radius-4' />
                    </TableCell>
                    <TableCell className='size-15'>10 000</TableCell>
                    <TableCell className='size-15'>2 000</TableCell>
                    <TableCell className='size-15'><Input placeholder='montant encaissé' /></TableCell>
                    <TableCell className='size-15'><Input placeholder='montant décaissé' /></TableCell>
                    <TableCell className='size-15'></TableCell>
                    <TableCell></TableCell>
                </TableRow>
                <TableRow>
                    <TableCell className='size-15'>
                        <img src='/images/orangemoney.png' alt='' width={42} height={40} className='radius-4' />
                    </TableCell>
                    <TableCell className='size-15'>10 000</TableCell>
                    <TableCell className='size-15'>2 000</TableCell>
                    <TableCell className='size-15'><Input placeholder='montant encaissé' /></TableCell>
                    <TableCell className='size-15'><Input placeholder='montant décaissé' /></TableCell>
                    <TableCell className='size-15'></TableCell>
                    <TableCell></TableCell>
                </TableRow>

                <TableRow>
                    <TableCell className='size-15'>
                        <img src='/images/freemoney.png' alt='' width={42} height={40} className='radius-4' />
                    </TableCell>
                    <TableCell className='size-15'>10 000</TableCell>
                    <TableCell className='size-15'>2 000</TableCell>
                    <TableCell className='size-15'><Input placeholder='montant encaissé' /></TableCell>
                    <TableCell className='size-15'><Input placeholder='montant décaissé' /></TableCell>
                    <TableCell className='size-15'></TableCell>
                    <TableCell></TableCell>
                </TableRow>

                <TableRow>
                    <TableCell className='size-15'>
                        <img src='/images/kash-kash.png' alt='' width={42} height={40} className='radius-4' />
                    </TableCell>
                    <TableCell className='size-15'>10 000</TableCell>
                    <TableCell className='size-15'>2 000</TableCell>
                    <TableCell className='size-15'><Input placeholder='montant encaissé' /></TableCell>
                    <TableCell className='size-15'><Input placeholder='montant décaissé' /></TableCell>
                    <TableCell className='size-15'></TableCell>
                    <TableCell></TableCell>
                </TableRow>
                <TableRow>
                    <TableCell className='size-15'>
                        <img src='/images/kpay.png' alt='' width={42} height={40} className='radius-4' />
                    </TableCell>
                    <TableCell className='size-15'>10 000</TableCell>
                    <TableCell className='size-15'>2 000</TableCell>
                    <TableCell className='size-15'><Input placeholder='montant encaissé' /></TableCell>
                    <TableCell className='size-15'><Input placeholder='montant décaissé' /></TableCell>
                    <TableCell className='size-15'></TableCell>
                    <TableCell></TableCell>
                </TableRow>
                <TableRow>
                    <TableCell className='size-15'>
                        <img src='/images/western-union.png' alt='' width={42} height={40} className='radius-4' />
                    </TableCell>
                    <TableCell className='size-15'>10 000</TableCell>
                    <TableCell className='size-15'>2 000</TableCell>
                    <TableCell className='size-15'><Input placeholder='montant encaissé' /></TableCell>
                    <TableCell className='size-15'><Input placeholder='montant décaissé' /></TableCell>
                    <TableCell className='size-15'></TableCell>
                    <TableCell>
                        <label style={css.uploadButton}><span className='mr-10'>Joindre un fichier</span> <img src='/images/upload1.png' alt='' width={27} /></label>
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell className='size-15'>
                        <img src='/images/moneygram.png' alt='' width={42} height={40} className='radius-4' />
                    </TableCell>
                    <TableCell className='size-15'>10 000</TableCell>
                    <TableCell className='size-15'>2 000</TableCell>
                    <TableCell className='size-15'><Input placeholder='montant encaissé' /></TableCell>
                    <TableCell className='size-15'><Input placeholder='montant décaissé' /></TableCell>
                    <TableCell className='size-15'></TableCell>
                    <TableCell><label style={css.uploadButton}><span className='mr-10'>Joindre un fichier</span> <img src='/images/upload1.png' alt='' width={27} /></label></TableCell>
                </TableRow>
                <TableRow>
                    <TableCell className='size-15'>
                        <img src='/images/ria.png' alt='' width={42} height={40} className='radius-4' />
                    </TableCell>
                    <TableCell className='size-15'>10 000</TableCell>
                    <TableCell className='size-15'>2 000</TableCell>
                    <TableCell className='size-15'><Input placeholder='montant encaissé' /></TableCell>
                    <TableCell className='size-15'><Input placeholder='montant décaissé' /></TableCell>
                    <TableCell className='size-15'></TableCell>
                    <TableCell><label style={css.uploadButton}><span className='mr-10'>Joindre un fichier</span> <img src='/images/upload1.png' alt='' width={27} /></label></TableCell>
                </TableRow>
                <TableRow>
                    <TableCell className='size-15'>
                        <img src='/images/smallworld.png' alt='' width={42} height={40} className='radius-4' />
                    </TableCell>
                    <TableCell className='size-15'>10 000</TableCell>
                    <TableCell className='size-15'>2 000</TableCell>
                    <TableCell className='size-15'><Input placeholder='montant encaissé' /></TableCell>
                    <TableCell className='size-15'><Input placeholder='montant décaissé' /></TableCell>
                    <TableCell className='size-15'></TableCell>
                    <TableCell><label style={css.uploadButton}><span className='mr-10'>Joindre un fichier</span> <img src='/images/upload1.png' alt='' width={27} /></label></TableCell>
                </TableRow>
            </TableBody>
        </Table>

    </div>
}